import { Component, OnInit } from '@angular/core';
import { AppMainComponent } from '../../../../app.main.component';
import { FieldsService } from './fields.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ProductService } from '../product.service';
import data from '../../staticJSON/fieldData.json';
import { ObjectNames, Status, Severity } from '../../constants/constants';
import { TitleCasePipe } from '@angular/common';
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: 'app-fields',
  templateUrl: './fields.component.html',
  styleUrls: ['./fields.component.scss'],
  providers: [ConfirmationService]
})
export class FieldsComponent implements OnInit {

  warrantyGroup: any;
  activeIndex: number = 0;
  productBrands = [];
  productWarranty = [];
  colorGroup;
  parentVariantGroup;
  productAddFieldForm: FormGroup;
  productTypeId: number = 0;
  productTypeName: string;
  addEditProductHeader: string;
  displayAddProductData: boolean = false;
  invalidData: boolean = false;
  selectedProductDataType;
  productDataTypes = data.fieldType;
  fieldDataConstants = ObjectNames.productConstants;
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  productColor = [];
  variants = [];
  displayProductAvailability: boolean = false;
  associatedProducts = '';

  constructor(private fieldService: FieldsService, private fb: FormBuilder, private app: AppMainComponent, private messageService: MessageService,
    private confirmationService: ConfirmationService, private productconfigService: ProductService,
    private titlecasePipe: TitleCasePipe) { }

  ngOnInit(): void {
    this.productconfigService.getProductField().subscribe(field => {
      if (field) {
        this.showAddProductData();
      }
    })
    this.callEvent({ index: 0 });
    this.productAddFieldForm = this.fb.group({
      id: [0],
      fieldType: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      createdSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      createdDate: [new Date().toISOString()],
      updatedBy: [0],
      updatedDate: [new Date().toISOString()],
      updatedSource: [this.app.userIP],
      description: [''],
      statusId: [Status.ACTIVE],
      parentTypeId: [0],
      parentGroupId: [0],
      groupId: [null],
      organizationId: [this.app.companyId],
      colorCodeId: [0],
    });
  }

  callEvent(event) {
    switch (event.index) {
      case 0:
        this.loadBrands();
        break;
      case 1:
        this.getInventoryGroups('warranty','list');
        break;
      case 2:
        this.getInventoryGroups('color','list');
        break;
      default:
        this.getInventoryGroups('variant','list');
        break;
    }
  }

  getInventoryGroups(type,action?) {
    this.fieldService.getInventoryGroupList().subscribe(groups => {
      if (type == 'warranty') {
        this.warrantyGroup = groups?.filter(s => s.name == ObjectNames.productConstants.titlewarrantyFieldName)[0];
        if(action || this.addEditProductHeader == ObjectNames.productConstants.AddFiedTitle){
          this.getInventoryWarrenty(this.warrantyGroup.id);
        }
      } else if (type == 'color') {
        this.colorGroup = groups?.filter(s => s.name == ObjectNames.productConstants.titleColorFieldName)[0];
        if(action || this.addEditProductHeader == ObjectNames.productConstants.AddFiedTitle){
          this.loadItemColors(this.colorGroup?.id);
        }
      } else {
        this.parentVariantGroup = groups.filter((group) => group.name == ObjectNames.productConstants.ProductGroupName)[0];
        if(action || this.addEditProductHeader == ObjectNames.productConstants.AddFiedTitle){
          this.getAllProductVariant(this.parentVariantGroup.id);
        }
      }
    });
  }

  getInventoryWarrenty(groupId) {
    this.fieldService.getWarrantyList(groupId).subscribe(warranty => {
      if (warranty) {
        this.productWarranty = warranty;
        this.productWarranty.sort((a, b) => a.name.localeCompare(b.name))
      }
    });
  }

  loadBrands() {
    this.fieldService.getBrandList().subscribe(brands => {
      if (brands) {
        this.productBrands = brands;
        this.productBrands.sort((a, b) => a.name.localeCompare(b.name))
      }
    })
  }

  loadItemColors(colorTypeId) {
    this.fieldService.getAllItemColor(colorTypeId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((colors) => {
      this.productColor = colors || [];
    })
  }

  getAllProductVariant(parentGroupId) {
    this.fieldService.getInventoryVariantGroups(parentGroupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((groups) => {
      this.variants = groups || [];
    });
  }


  showAddProductData() {
    this.selectedProductDataType = null;
    this.productAddFieldForm = this.fb.group({
      id: [0],
      fieldType: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      createdSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      createdDate: [new Date().toISOString()],
      updatedBy: [this.app.user.userId],
      updatedDate: [new Date().toISOString()],
      updatedSource: [this.app.userIP],
      description: [''],
      statusId: [1],
      parentTypeId: [0],
      groupId: [0],
      parentGroupId: [0],
      organizationId: [this.app.companyId],
      colorCodeId: [0]
    });
    this.displayAddProductData = true;
    this.addEditProductHeader = ObjectNames.productConstants.AddFiedTitle;
    this.invalidData = false;
  }

  showEditProductData(c, s) {
    this.productAddFieldForm.patchValue(c);
    const filteredField = this.productDataTypes.filter(field => field.code.toLowerCase() == s)[0];
    this.productTypeId = filteredField.id;
    this.productAddFieldForm.get('fieldType').setValue(filteredField);
    this.productAddFieldForm.get('parentGroupId').setValue(c.parentGroupId);
    this.productTypeName = filteredField.name;
    this.addEditProductHeader = ObjectNames.productConstants.EditFieldTitle;
    this.displayAddProductData = true;
  }


  saveProductDataAdd(value) {
    if (this.addEditProductHeader == ObjectNames.productConstants.AddFiedTitle) {
      if (value.fieldType.code == ObjectNames.productConstants.brandFieldName) {
        const lowerCaseNames = [];
        for (let s of this.productBrands) {
          lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }
        if (lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, '')) > -1) {
          this.invalidData = true;
        } else {
          delete value['fieldType'];
          delete value['parentGroupId'];
          delete value['parentTypeId'];
          delete value['groupId'];
          delete value['organizationId'];
          delete value['colorCodeId'];
          this.fieldService.addBrandList(value).then(res => {
            this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Added Successfully...' });
            this.loadBrands();
            this.displayAddProductData = false;
          });
        }
      } else if (value.fieldType.code == ObjectNames.productConstants.titlewarrantyFieldName.toLowerCase()) {
        value.groupId = this.warrantyGroup?.id;
        const lowerCaseNames = [];
        for (let s of this.productWarranty) {
          lowerCaseNames.push(s.name.toLowerCase())
        }
        if (lowerCaseNames.indexOf(value.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          delete value['fieldType'];
          delete value['parentGroupId'];
          this.fieldService.addWarrantyList(value).then(stages => {
            this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Added Successfully...' });
            this.getInventoryWarrenty(this.warrantyGroup.id);
            this.displayAddProductData = false;
          });
        }
      }else if(value.fieldType.code == ObjectNames.productConstants.colorFieldName){
        value.groupId = this.colorGroup?.id;
        const lowerCaseNames = [];
        for (let s of this.productColor) {
          lowerCaseNames.push(s.name.toLowerCase())
        }
        if (lowerCaseNames.indexOf(value.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          delete value['fieldType'];
          delete value['parentGroupId'];
          this.fieldService.addItemColor(value).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((colors) => {
            this.displayAddProductData = false;
            this.getInventoryGroups('color','list')
          })
        }
      }else if(value.fieldType.code == ObjectNames.productConstants.variantFieldName){
        value.parentGroupId = this.parentVariantGroup?.id;
        value.groupOrganization= {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          groupId: 0,
          organizationId: this.app.companyId,
          statusId: 1
       }
        const lowerCaseNames = [];
        for (let s of this.variants) {
          lowerCaseNames.push(s.name.toLowerCase())
        }
        if (lowerCaseNames.indexOf(value.name.toLowerCase()) > -1) {
          this.invalidData = true;
        } else {
          delete value['fieldType'];
          this.fieldService.addInventoryVariantGroups(value).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((variant) => {
            this.displayAddProductData = false;
            this.getInventoryGroups('variant','list')
          })
        }
      }
    } else if (this.addEditProductHeader == ObjectNames.productConstants.EditFieldTitle) {
      if (this.productTypeId == data.fieldType[1].id) {
        const duplicateRecord = this.productWarranty?.find(depOb => depOb.name.toLowerCase() == value.name.toLowerCase() && depOb.id !== value.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          delete value['fieldType'];
          delete value['parentGroupId'];
          this.fieldService.updateWarrantyList(value).then(stages => {
            this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Updated Successfully...' });
            this.getInventoryWarrenty(this.warrantyGroup.id);
            this.displayAddProductData = false;
          });
        }
      } else if (this.productTypeId == data.fieldType[0].id) {
        const duplicateRecord = this.productBrands?.find(depOb => depOb.name.toLowerCase().replace(/ /g, '') == value.name.toLowerCase().replace(/ /g, '') && depOb.id !== value.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          delete value['fieldType'];
          delete value['parentTypeId'];
          delete value['groupId'];
          delete value['colorCodeId'];
          delete value['parentGroupId'];
          this.fieldService.updateBrandList(value).then(stages => {
            this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Updated Successfully...' });
            this.loadBrands();
            this.displayAddProductData = false;
          });

        }
      }else if(this.productTypeId == data.fieldType[2].id){
        const duplicateRecord = this.productColor?.find(depOb => depOb.name.toLowerCase() == value.name.toLowerCase() && depOb.id !== value.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }

        if (!this.invalidData) {
          delete value['fieldType'];
          delete value['parentGroupId'];
          this.fieldService.updateItemColor(value).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((colors) => {
            this.displayAddProductData = false;
           this.getInventoryGroups('color','list')
          })
        }
      }else if(this.productTypeId == data.fieldType[3].id){
        const duplicateRecord = this.variants?.find(depOb => depOb.name.toLowerCase() == value.name.toLowerCase() && depOb.id !== value.id)
        if (duplicateRecord) {
          this.invalidData = true;
        } else {
          this.invalidData = false;
        }
        if (!this.invalidData) {
          delete value['fieldType'];
          this.fieldService.updateInventoryVariantGroups(value).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((colors) => {
            this.displayAddProductData = false;
            this.getInventoryGroups('variant','list')
          })
        }
      }
    }
  }

  checkDeleteStatus(data,type){
      this.fieldService.checkProductAvailability(data.id,type).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(check => {
        if (check.item1) {
          this.displayProductAvailability = true;
          this.associatedProducts = check.item2;
        }else{
          this.delete(data,type);
        }
      })
    }
  

  delete(data, type) {
    this.confirmationService.confirm({
      message: `Do you want to delete this ${type}?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        switch (type) {
          case ObjectNames.productConstants.titleCasebrandFieldName:
            this.deleteBrand(data);
            break;
          case ObjectNames.productConstants.titlewarrantyFieldName:
            this.deleteWarranty(data);
            break;
          case ObjectNames.productConstants.colorFieldName:
            this.deleteColor(data);
            break;
          default:
            this.deleteVariant(data);
            break;
        }
      },
      reject: () => {
      }
    });
  }

  deleteBrand(brand) {
    this.fieldService.deleteBrandList(brand.id).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
      this.productBrands?.splice(this.productBrands?.findIndex((i)=> {
        return i.id === brand.id;
      }), 1);
    }).catch(() => {
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
    });
  }

  deleteWarranty(warranty) {
    this.fieldService.deleteWarrantyList(warranty.id).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
      this.productWarranty?.splice(this.productWarranty?.findIndex((i)=> {
        return i.id === warranty.id;
      }), 1);
    }).catch(() => {
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
    });
  }

  deleteColor(color){
    this.fieldService.deleteWarrantyList(color.id).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
      this.productColor?.splice(this.productColor?.findIndex((i)=> {
        return i.id === color.id;
      }), 1);
    }).catch(() => {
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
    });
  }
  
  deleteVariant(variant){
    this.fieldService.deleteVariant(variant.id).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
      this.variants?.splice(this.variants?.findIndex((i)=> {
        return i.id === variant.id;
      }), 1);
    }).catch(() => {
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
    });
  }


  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }

}
